import AdministrationHome from './Home'
import SettingsEmails from './emails/Emails'
import EmailTemplatesView from './emails/View'
import Languages from './languages/Languages'
import LanguagesView from './languages/View'
import LanguagesCreate from './languages/Create'

import Translations from './translations/Translations'
import TranslationsView from './translations/View'

import DateAndTime from './date-and-time/DateAndTime'

import Currencies from './currencies/Currencies'
import CurrenciesView from './currencies/View'
import CurrenciesCreate from './currencies/Create'

import SocialMediaLinksView from './social-media/SocialMediaLinks'

import MainContactsView from './main-contacts/MainContacts'

import APIManager from './api-manager/APIManager'

import Users from './users/Users'
import UsersCreate from './users/Create'
import UsersView from './users/View'

import ClientIdentities from './client/identity/ClientIdentities'
import ClientIdentityView from './client/identity/View'
import ClientIdentityCreate from './client/identity/Create'

import ClientThemes from './client/theme/ClientThemes'
import ClientThemeView from './client/theme/View'
import ClientThemeCreate from './client/theme/Create'

import Navigation from './navigation/Navigation'
import NavigationView from './navigation/View'
import NavigationCreate from './navigation/Create'

import WebsiteBuilder from './website-builder/WebsiteBuilder'

const Modules = {
    AdministrationHome,
    SettingsEmails,
    EmailTemplatesView,

    Languages,
    LanguagesView,
    LanguagesCreate,

    Translations,
    TranslationsView,

    DateAndTime,

    Currencies,
    CurrenciesView,
    CurrenciesCreate,

    SocialMediaLinksView,

    MainContactsView,

    APIManager,

    Users,
    UsersCreate,
    UsersView,

    ClientIdentities,
    ClientIdentityView,
    ClientIdentityCreate,

    ClientThemes,
    ClientThemeView,
    ClientThemeCreate,

    Navigation,
    NavigationView,
    NavigationCreate,

    WebsiteBuilder,
}

export default Modules
